document.addEventListener("DOMContentLoaded", (event) => {
  // Init swiper content block about page
  const sectionContentBlock = document.querySelectorAll('.at-about-content-block')
  if (sectionContentBlock.length > 0) {
    sectionContentBlock.forEach(section => {
      const swiper = new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 3,
        slidesPerView: 'auto'
      })
    })
  }
})
